(function () {
  var escapeListenerBound = false;

  function init(root) {
    if (!root || root.dataset.magioStickyNavInit === '1') return;
    root.dataset.magioStickyNavInit = '1';

    document.body.classList.add('magio-has-sticky-nav');
    initMobileHeroNav(root);

    var toggle = root.querySelector('[data-magio-sticky-nav-toggle]');
    var sheet = root.querySelector('[data-magio-sticky-nav-sheet]');
    var panel = root.querySelector('[data-magio-sticky-nav-panel]');
    var closeBtn = root.querySelector('[data-magio-sticky-nav-close]');
    if (!toggle || !sheet) return;

    function collapseSubmenus() {
      root.querySelectorAll('.magio-sticky-nav__sheet-item--group.is-expanded').forEach(function (item) {
        item.classList.remove('is-expanded');
        var row = item.querySelector('.magio-sticky-nav__sheet-link-row');
        if (row) {
          row.setAttribute('aria-expanded', 'false');
          if (row.blur) row.blur();
        }
      });
    }

    function setOpen(open) {
      root.classList.toggle('is-menu-open', open);
      sheet.classList.toggle('is-open', open);
      sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open
        ? (toggle.dataset.closeLabel || 'Close menu')
        : (toggle.dataset.openLabel || 'Menu'));
      document.body.classList.toggle('magio-sticky-nav-open', open);
      document.documentElement.classList.toggle('magio-sticky-nav-open', open);

      if (!open) {
        collapseSubmenus();
        toggle.focus({ preventScroll: true });
      }
    }

    function isOpen() {
      return root.classList.contains('is-menu-open');
    }

    toggle.dataset.openLabel = toggle.getAttribute('aria-label') || 'Menu';
    toggle.dataset.closeLabel = 'Close menu';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!isOpen());
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
      });
    }

    sheet.addEventListener('click', function (event) {
      if (panel && panel.contains(event.target)) return;
      setOpen(false);
    });

    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    function toggleSubmenuItem(item) {
      if (!item) return;
      var row = item.querySelector('.magio-sticky-nav__sheet-link-row');
      var expanded = item.classList.toggle('is-expanded');
      if (row) {
        row.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (document.activeElement === row) row.blur();
      }
    }

    sheet.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        if (link.closest('.magio-sticky-nav__sheet-link-row')) return;
        setOpen(false);
      });
    });

    root.querySelectorAll('.magio-sticky-nav__sheet-item--group.has-children .magio-sticky-nav__sheet-link-row').forEach(function (row) {
      function onRowActivate(event) {
        event.preventDefault();
        event.stopPropagation();
        toggleSubmenuItem(row.closest('.magio-sticky-nav__sheet-item--group'));
        if (row.blur) row.blur();
      }

      row.addEventListener('click', onRowActivate);
      row.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        onRowActivate(event);
      });
    });

    if (!escapeListenerBound) {
      escapeListenerBound = true;
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-magio-sticky-nav].is-menu-open').forEach(function (openRoot) {
          openRoot.classList.remove('is-menu-open');
          openRoot.querySelectorAll('.magio-sticky-nav__sheet-item--group.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            var row = item.querySelector('.magio-sticky-nav__sheet-link-row');
            if (row) row.setAttribute('aria-expanded', 'false');
          });
          var openSheet = openRoot.querySelector('[data-magio-sticky-nav-sheet]');
          var openToggle = openRoot.querySelector('[data-magio-sticky-nav-toggle]');
          if (openSheet) {
            openSheet.classList.remove('is-open');
            openSheet.setAttribute('aria-hidden', 'true');
          }
          if (openToggle) {
            openToggle.setAttribute('aria-expanded', 'false');
            openToggle.setAttribute('aria-label', openToggle.dataset.openLabel || 'Menu');
          }
        });
        document.body.classList.remove('magio-sticky-nav-open');
        document.documentElement.classList.remove('magio-sticky-nav-open');
      });
    }
  }

  function initMobileHeroNav(root) {
    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var heroPages = ['magio-hair-services-page', 'magio-nail-services-page', 'magio-services-page'];
    var hasHeroPage = heroPages.some(function (cls) {
      return document.body.classList.contains(cls);
    });

    if (!hasHeroPage) {
      root.classList.add('is-solid');
      return;
    }

    var hero = document.querySelector('.magio-hair-hero, .magio-services-hero');
    if (!hero) {
      root.classList.add('is-solid');
      return;
    }

    function syncNavChrome() {
      if (!mobileQuery.matches) {
        root.classList.remove('is-solid');
        return;
      }

      var navRect = root.getBoundingClientRect();
      var heroRect = hero.getBoundingClientRect();
      /* Only treat as overlay when the hero actually intersects the fixed nav */
      var overHero = heroRect.top < navRect.bottom - 4 && heroRect.bottom > navRect.top + 4;
      root.classList.toggle('is-solid', !overHero);
    }

    syncNavChrome();
    window.addEventListener('scroll', syncNavChrome, { passive: true });
    window.addEventListener('resize', syncNavChrome, { passive: true });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncNavChrome);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(syncNavChrome);
    }
  }

  function syncHomeChromeHeight() {
    var nav = document.querySelector('.magio-sticky-nav');
    var promo = document.querySelector('.magio-promo-bar:not(.is-dismissed)');
    var chromeBottom = 0;
    if (nav) {
      chromeBottom = nav.getBoundingClientRect().bottom;
    } else if (promo) {
      chromeBottom = promo.getBoundingClientRect().bottom;
    }

    var viewport = window.visualViewport;
    var viewportBottom = viewport
      ? viewport.offsetTop + viewport.height
      : window.innerHeight;
    var heroHeight = Math.max(240, Math.round(viewportBottom - chromeBottom));

    document.documentElement.style.setProperty('--magio-home-chrome-h', Math.max(0, Math.round(chromeBottom)) + 'px');
    document.documentElement.style.setProperty('--magio-home-split-panel-h', heroHeight + 'px');
    document.documentElement.style.setProperty('--magio-home-banner-h', heroHeight + 'px');
  }

  var homeChromeBound = false;

  function bindHomeChromeSync() {
    syncHomeChromeHeight();
    requestAnimationFrame(syncHomeChromeHeight);
    if (homeChromeBound) return;
    homeChromeBound = true;
    window.addEventListener('resize', syncHomeChromeHeight);
    window.addEventListener('load', syncHomeChromeHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncHomeChromeHeight);
      window.visualViewport.addEventListener('scroll', syncHomeChromeHeight);
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-magio-sticky-nav]').forEach(init);
    bindHomeChromeSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
